import type { IconProps } from './IconProps';

export const BinanceIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M5.4711 6.99853L7.99933 4.2264L10.5289 7L12 5.38691L7.99933 1L4 5.38545L5.4711 6.99853Z"
      fill="currentColor"
    />
    <path
      d="M4.09369 7.99994L2.51172 6.41797L0.929669 8.00002L2.51164 9.58199L4.09369 7.99994Z"
      fill="currentColor"
    />
    <path
      d="M5.47273 9.00135L8.00005 11.7735L10.5286 9L12 10.6122L11.9993 10.6131L8.00005 15L4.00206 10.6146L4 10.6123L5.47273 9.00135Z"
      fill="currentColor"
    />
    <path
      d="M13.3476 9.58205L14.9297 8L13.3477 6.41803L11.7657 8.00008L13.3476 9.58205Z"
      fill="currentColor"
    />
    <path
      d="M9.99821 7.99897H9.99904L8 6L6.52268 7.47726H6.52255L6.35291 7.64703L6.00275 7.99718L6 7.99993L6.00275 8.00282L8 10L9.99904 8.00103L10 7.99993L9.99821 7.99897Z"
      fill="currentColor"
    />
  </svg>
);
